import styled from '@emotion/styled';
import { colors } from 'Constants/Colors';

export const DateRangePickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;
  font-family: 'Roboto', sans-serif;
`;

export const DateRangePickerLabel = styled.label<{ hidden?: boolean }>`
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  color: ${colors.GRAY_DARK};
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
`;

export const DateRangeInput = styled.div<{ hasValue?: boolean }>`
  display: flex;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  background: white;
  height: 50px;
  padding: 0 0.75rem;
  cursor: pointer;
  min-width: 180px;
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
  color: ${({ hasValue }) => (hasValue ? 'black' : colors.GRAY)};
`;

export const CalendarPopup = styled.div<{ top?: number; left?: number }>`
  position: fixed;
  top: ${({ top }) => top ?? 0}px;
  left: ${({ left }) => left ?? 0}px;
  z-index: 1400;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  background: white;
  font-family: 'Roboto', sans-serif;

  /* Estilos para react-date-range */
  .rdrCalendarWrapper {
    font-family: 'Roboto', sans-serif;
    border-radius: 8px;
  }

  .rdrDateDisplayWrapper {
    background-color: ${colors.GREEN};
  }

  .rdrDateDisplayItem {
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid transparent;
  }

  .rdrDateDisplayItemActive {
    border-color: white;
  }

  .rdrMonthAndYearWrapper {
    padding-top: 10px;
  }

  .rdrMonthAndYearPickers select {
    font-family: 'Roboto', sans-serif;
  }

  .rdrDayNumber span {
    font-family: 'Roboto', sans-serif;
  }

  .rdrDayToday .rdrDayNumber span:after {
    background: ${colors.GREEN};
  }

  .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span {
    color: ${colors.GRAY_DARKER};
  }

  .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span {
    color: white;
  }

  .rdrStartEdge,
  .rdrEndEdge {
    background: ${colors.GREEN};
  }

  .rdrInRange {
    background: ${colors.GREEN_ULTRA_LIGHT};
  }

  .rdrDayStartPreview,
  .rdrDayInPreview,
  .rdrDayEndPreview {
    border-color: ${colors.GREEN};
  }

  .rdrDefinedRangesWrapper {
    display: none;
  }

  .rdrNextPrevButton {
    background: ${colors.GREEN_ULTRA_LIGHT};
  }

  .rdrNextPrevButton:hover {
    background: ${colors.GREEN_LIGHT_OPACITY};
  }

  .rdrPprevButton i {
    border-color: transparent ${colors.GREEN} transparent transparent;
  }

  .rdrNextButton i {
    border-color: transparent transparent transparent ${colors.GREEN};
  }

  .rdrSelected,
  .rdrStartEdge,
  .rdrEndEdge {
    background: ${colors.GREEN};
  }

  .rdrDayHovered .rdrDayNumber:after {
    border-color: ${colors.GREEN};
  }

  .rdrMonthName {
    font-family: 'Roboto', sans-serif;
    color: ${colors.GRAY_DARK};
  }

  .rdrWeekDay {
    font-family: 'Roboto', sans-serif;
    color: ${colors.GRAY_DARK};
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1399;
`;
